/** A report's own page in VectorSurv, the printable one, or "" when the id is not
 *  a VectorSurv report number. Digits only, so an id cannot add anything to the
 *  address. The same link the dead bird watcher's email uses. */
export function reportUrl(id: string | number | null | undefined): string {
    const rid = String(id ?? "").trim();
    return /^\d+$/.test(rid)
        ? `https://gateway.vectorsurv.org/print.php?height=450&width=700&scrollbars=1&menubar=1&module=carcass&ppf=report&id=${rid}`
        : "";
}
